function initPage4(vm, FileTemplateService, self) {
	//load benRelationshipItems
	FileTemplateService.query({uri:'getBenRelationshipItems',flgStartUp:false}, function(result){
		vm.benRelationshipItems = result;		
	});
	vm.checkBenList = true;
	vm.checkTotalBenList = function(){				
		var totalBenList = 0;
		vm.checkAllBen  = false;
		for ( var ben in vm.proposal.benList) {
			if(vm.proposal.benList[ben].customer.idNum != null && vm.proposal.benList[ben].customer.idNum != '') {
				totalBenList +=  Number(vm.proposal.benList[ben].percent);
				vm.checkAllBen = true;
			}
			if(vm.proposal.benList[ben].relationshipCode == null){
				vm.proposal.benList[ben].relationshipCode = '';
			}
			if(vm.proposal.benList[ben].relationshipType == null){
				vm.proposal.benList[ben].relationshipType = 'KHAC';
			}
		}
		if(vm.checkAllBen && totalBenList == 100){
			vm.checkBenList = false;
		}else{
			vm.checkBenList = true;
		}
	}	
	//config birthdate
	vm.defaultPage4 = function(){
		vm.dob =[false, false, false, false];
		vm.openDatePickerPage4 = function(index) {	
			vm.dob[index] = true;
		};		
		vm.checkTotalBenList();
	};
	
	vm.defaultPage4();
	vm.requiedBenRelationshipCode = [];
	vm.benCMNDPage4 = function(index){		
		if(vm.proposal.benList[index].customer.idNum != null && vm.proposal.benList[index].customer.idNum != '') {
			vm.requiedBenRelationshipCode[index] = true;
		}else{
			vm.requiedBenRelationshipCode[index] = false;
		}		
	}
	
	vm.validatePage4 = function(){
		var flag = false;		
		flag = vm.validateAllRequired(flag);	
		if(vm.checkAllBen && vm.checkBenList ){
			self.addAlert('% Được hưởng = 100%.','danger');
			flag = true;
		}			
		//remove text if idnum = null or ''
		for ( var index in vm.proposal.benList) {			
			if(vm.proposal.benList[index].customer.idNum == null || vm.proposal.benList[index].customer.idNum == '') {
				vm.proposal.benList[index].relationshipCode = '';
				vm.proposal.benList[index].percent = null;			
				vm.proposal.benList[index].customer.lastName = '';
				vm.proposal.benList[index].customer.firstName = '';
				vm.proposal.benList[index].customer.gender = null;
				vm.proposal.benList[index].customer.dob = '';
				vm.proposal.benList[index].customer.nationality = 'VN';
				vm.proposal.benList[index].customer.street = '';
			}else{
				vm.calculaNumberYearPage4(vm.proposal.insuranceDate,vm.proposal.benList[index].customer.dob,index);
			}
		}
		return flag;
	}
	vm.calculaNumberYearPage4 = function(date, dob, type) {
		if(!moment(dob).isValid()){
			return;
		}
		if (date === undefined || date === null || dob === undefined
				|| dob === null) {
			return;
		}
		dob = new Date(dob).getTime();
		FileTemplateService.get({
			uri : 'calculateAge',
			birthMsDate : dob,
			trMsDate : vm.proposal.receiptDate
		}, function(result) {
			if (result !== null) {
				if (type == 0) {
					if (result.age > 120) {
						self.addAlert('Tuổi Người Thụ Hưởng phải nhỏ hơn 120','danger');
						vm.flagAgeValidate = true;
					}else{
						vm.flagAgeValidate = false;
					}
				} else if (type ==1 && vm.flagAgeValidate == false) {
					if (result.age > 120) {
						self.addAlert('Tuổi Người Thụ Hưởng phải nhỏ hơn 120','danger');
						vm.flagAgeValidate = true;
					}else{
						vm.flagAgeValidate = false;
					}
				} else if (type === 2 && vm.flagAgeValidate == false) {
					if (result.age > 120) {
						self.addAlert('Tuổi Người Thụ Hưởng phải nhỏ hơn 120','danger');
						vm.flagAgeValidate = true;
					}else{
						vm.flagAgeValidate = false;
					}
				} else if (type == 3 && vm.flagAgeValidate == false) {
					vm.proposal.laList[2].customer.age = result.age;
					if (result.age > 120) {
						self.addAlert('Tuổi Người Thụ Hưởng phải nhỏ hơn 120', 'danger');
						vm.flagAgeValidate = true;
					}else{
						vm.flagAgeValidate = false;
					}
				} 
			}
		});
	};
}